import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TransactionAttachmentModal from "./transactionAttachmentModal.js";

function mapStateToProps(state) {
  return {
    texts: state.translatedTexts,
    actionType: state.actionType,
    transactions: state.transactions,
    transactionAttachments: state.transactionAttachments,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionAttachmentModal);
